<template lang="pug">
  div
    v-card.py-3(tile flat @click="openOrderItemDetailsDialog = true")
      v-row.mb-3(no-gutters align="center")
        v-col.px-4.shrink
          y-checkbox.mb-n3.mr-n2(v-model="checkbox" style="height:30px")
        v-col
          div.p2.basic600--text # {{ lead.rid }} {{ (lead.processed_at || lead.created) | convertServerDate }}
        v-col.px-4.shrink
          v-chip.button-AA-tiny.text-uppercase(v-if="lead.status === 'shipped'" x-small color="warning500" style="height: 20px; border-radius: 10px;" dark) {{ $t('shipping') }}
          v-chip.button-AA-tiny.text-uppercase(v-if="lead.status === 'received'" x-small color="basic500" style="height: 20px; border-radius: 10px;" dark) {{ $t('delivered') }}
      div.px-4
        div.s2.info500--text {{ ((lead.shipping_address && lead.shipping_address.name) || lead.name) }}
        div.p2.basic700--text.mb-2 {{ ((lead.shipping_address && lead.shipping_address.phone) || lead.phone) | phoneFormat }}

        .fulfilment-info(v-if="lead.shipping")
          template(v-if="lead.pickup || lead.shipping.courier || lead.shipping.on_demand || lead.shipping.shipping_method !== 'manual' || lead.status === 'received'")
            div.c1.basic600--text.mb-1 {{ $t('picked_up_by') }}
            div.d-flex.align-center.mb-1
              eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
              div
                div.p2.basic700--text(v-if="lead.pickup") {{ $t('self_pickup') }}
                div.p2.basic700--text(v-else-if="lead.shipping.courier || lead.shipping.on_demand") {{ lead.shipping.courier || lead.shipping.on_demand }}
                div.p2.basic700--text(v-else) {{ lead.shipping.shipping_method | shippingMethodDisplay }}

              template(v-if="lead.shipping.tracking_id")
                v-spacer
                div.p2.basic600--text {{ lead.shipping.tracking_id }}

            div.d-flex.align-center.mb-1(v-if="lead.statuses && lead.statuses.filter(f => f.status === 'shipped' || f.status === 'received').length > 0")
              eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
              div.p2.basic700--text(v-if="lead.statuses.filter(f => f.status === 'shipped' || f.status === 'received')[0].created") {{ lead.statuses[0].created | convertServerDateWithZone }}

            v-row.mb-1(no-gutters v-if="lead.status === 'shipped' && lead.shipping && lead.shipping.on_demand_details")
              v-col.shrink.pr-1
                eva-icon.mb-n1(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
              v-col.pr-6(cols="10")
                div.p2.basic700--text(style="margin-top: 1px;") {{ lead.shipping.on_demand_details }}
          template(v-if="lead.shipping && lead.status !== 'received' && ((lead.status === 'shipped' && lead.shipping.shipping_method === 'manual') || (lead.shipping.shipping_method === 'easyparcel' && (lead.shipping.status == 'pending' || lead.shipping.status == 'processing')))")
            a.p2.info500--text(v-if="!lead.shipping.tracking_id && !lead.shipping.on_demand" @click="") {{ $t('update_tracking_info') }}
        
        div.d-flex.mt-4.mb-2(v-if="details.amountPaid && lead.products.length > 0")
          div.c1.basic700--text {{ lead.products.length > 1 ? lead.products.length + ' items' : lead.products.length + ' item' }}
          div.c1.basic700--text.ml-4 {{ lead.products.reduce((sum, p) => { return sum + (p.price_per_set * p.quantity) }, 0) | displayPrice }} {{ !lead.paid ? 'unpaid' : '' }}
          template(v-if="lead.cod || lead.pay_at_shop")
            v-spacer
            v-chip.button-AA-tiny.text-uppercase(v-if="lead.cod" x-small dark color="primary" style="height: 20px; border-radius: 10px;") {{ $t('cod') }}
            v-chip.button-AA-tiny.text-uppercase(v-if="lead.pay_at_shop" x-small dark color="primary" style="height: 20px; border-radius: 10px;") {{ $t('pay_at_shop') }}

    .modals
      order-item-details(v-if="openOrderItemDetailsDialog" :open.sync="openOrderItemDetailsDialog" :parentLead.sync="lead" :menu="menu" @deleted="$emit('deleted', $event)")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OrderItemDetails from '@/components/dialogs/order/OrderItemDetails.vue'

export default {
  name: 'PostOrderItem',
  props: ['parentLead', 'menu', 'checkboxActiveExport', 'checkboxActiveShipping'],
  components: { OrderItemDetails },
  data: () => ({
    openOrderItemDetailsDialog: false,
    setTimeOutTooltip: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      details: 'orders/getOrderDetails',
      view: 'orders/getOrderView',
      selectedLeads: 'orders/getSelectedLeads'
    }),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    checkbox: {
      get () {
        if (this.selectedLeads.filter(f => f.id === this.lead.id)[0]) {
          return true
        }
        return false
      },
      set (val) {
        if (val) {
          this.$store.commit('orders/addLead', this.lead)
        } else {
          this.$store.commit('orders/deleteLead', this.lead)
        }
      }
    }
  },
}
</script>

<style scoped>
.order-title:hover{
  text-decoration: underline;
  cursor: pointer;
}
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>

<i18n>
{
  "en": {
    "picked_up_by": "Picked up by",
    "update_tracking_info": "Update tracking info",
    "cod": "COD"
  },
  "id": {
     "picked_up_by": "Dipungut oleh",
    "update_tracking_info": "Perbaru info pelacakan",
    "cod": "COD"
  }
}
</i18n>